// Password validation utility functions

export const PASSWORD_RULES = {
  minLength: 8,
  requireUppercase: true,
  requireSpecial: true,
};

export const SPECIAL_CHARS = '!@#$%^&*()_+-=[]{};\':"|,.<>/?';

export const validatePassword = (password) => {
  const rules = {
    minLength: password.length >= PASSWORD_RULES.minLength,
    hasUppercase: /[A-Z]/.test(password),
    hasSpecial: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password),
  };
  
  const isValid = rules.minLength && rules.hasUppercase && rules.hasSpecial;
  
  return {
    rules,
    isValid,
  };
};

export const getPasswordStrength = (password) => {
  if (!password) return { score: 0, label: 'Nessuna', color: 'gray' };
  
  let score = 0;
  
  // Length scoring
  if (password.length >= 8) score += 1;
  if (password.length >= 12) score += 1;
  if (password.length >= 16) score += 1;
  
  // Character variety
  if (/[a-z]/.test(password)) score += 1;
  if (/[A-Z]/.test(password)) score += 1;
  if (/[0-9]/.test(password)) score += 1;
  if (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) score += 1;
  
  // Map score to strength
  if (score <= 2) return { score, label: 'Debole', color: 'red' };
  if (score <= 4) return { score, label: 'Media', color: 'yellow' };
  if (score <= 6) return { score, label: 'Forte', color: 'green' };
  return { score, label: 'Molto Forte', color: 'emerald' };
};
